// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"Rolet_containerDashboardP__AeSf6"};